import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const UnitCountFour = () => {
  const [traderCount, setTotalTraderCount] = useState("");
  const [studentCount, setTotalStudentCount] = useState("");
  const [tutorCount, setTotalTutorCount] = useState("");
  const [guestCount, setTotalGuestCount] = useState("");
  const [batchCount, setTotalBatchCount] = useState("");

  const [newtraderCount, setNewTraderCount] = useState("");
  const [newstudentCount, setNewStudentCount] = useState("");
  const [newtutorCount, setNewTutorCount] = useState("");
  const [newguestCount, setNewGuestCount] = useState("");
  const [newbatchCount, setNewBatchCount] = useState("");
  const [roleName, setRoleName] = useState("");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    if (!user || !storedToken) {
      navigate("/");
      return;
    }
    const parsedUser = JSON.parse(user);
    setRoleName(parsedUser?.rolename);
    setUserName(parsedUser?.userName);
  }, [navigate]);

  const fetchCount = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      let url;
      const urlAll = `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-dashboard-count`;
      const urlTutor = `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-dashboard-count-tutor`;

      if (roleName === "Tutor" && userName !== "E2TMT0001") {
        console.log(
          "Tutor role detected, fetching tutor-specific data",
          roleName,
          userName
        );
        url = urlTutor;
      } else {
        url = urlAll;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTotalTraderCount(response?.data?.traderCount);
      setTotalStudentCount(response?.data?.studentCount);
      setTotalTutorCount(response?.data?.tutorCount);
      setTotalGuestCount(response?.data?.guestCount);
      setTotalBatchCount(response?.data?.batchCount);

      setNewStudentCount(response?.data?.newStudentCount);
      setNewTraderCount(response?.data?.newTraderCount);
      setNewTutorCount(response?.data?.newTutorCount);
      setNewGuestCount(response?.data?.newGuestCount);
      setNewBatchCount(response?.data?.newBatchCount);
      //   // console.log(response);

      // console.log(response);
    } catch (error) {
      // console.log(error);
    }
  });
  useEffect(() => {
    fetchCount();
  }, [roleName, userName]);

  return (
    <>
      {/* Dashboard Widget Start */}
      <div className="col-xxl-3 col-sm-6">
        <div className="card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-3">
          <div className="card-body p-0">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
              <div className="d-flex align-items-center">
                <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center me-20">
                  <span className="mb-0 w-40-px h-40-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center radius-8 h6 mb-0">
                    <Icon icon="flowbite:users-group-solid" className="icon" />
                  </span>
                </div>
                <div>
                  <span className="mb-2 fw-medium text-secondary-light text-md">
                    Total Students
                  </span>
                  <h6 className="fw-semibold my-1">{studentCount}</h6>
                  <p className="text-sm mb-0">
                    New Students{" "}
                    <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                      +{newstudentCount}
                    </span>{" "}
                    in last one month
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Dashboard Widget End */}
      {(roleName === "Admin" || userName === "E2TMT0001") && (
        <div className="col-xxl-3 col-sm-6">
          <div className="card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-2">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center">
                  <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center me-20">
                    <span className="mb-0 w-40-px h-40-px bg-purple flex-shrink-0 text-white d-flex justify-content-center align-items-center radius-8 h6 mb-0">
                      <Icon
                        icon="solar:wallet-bold"
                        className="text-white text-2xl mb-0"
                      />
                    </span>
                  </div>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-md">
                      Total Trader
                    </span>
                    <h6 className="fw-semibold my-1">{traderCount}</h6>
                    <p className="text-sm mb-0">
                      New Traders{" "}
                      <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                        +{newtraderCount}
                      </span>{" "}
                      in last one month
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dashboard Widget End */}
      {/* Dashboard Widget Start */}

      {(roleName === "Admin" || userName === "E2TMT0001") && (
        <div className="col-xxl-3 col-sm-6">
          <div className="card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-5">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center">
                  <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center me-20">
                    <span className="mb-0 w-40-px h-40-px bg-red flex-shrink-0 text-white d-flex justify-content-center align-items-center radius-8 h6 mb-0">
                      <Icon
                        icon="fa6-solid:file-invoice-dollar"
                        className="text-white text-2xl mb-0"
                      />
                    </span>
                  </div>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-md">
                      Total Guest
                    </span>
                    <h6 className="fw-semibold my-1">{guestCount}</h6>
                    <p className="text-sm mb-0">
                      New guests{" "}
                      <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                        +{newguestCount}
                      </span>
                      in last one month
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dashboard Widget End */}
      {/* Dashboard Widget Start */}

      {(roleName === "Admin" || userName === "E2TMT0001") && (
        <div className="col-xxl-3 col-sm-6">
          <div className="card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-4">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center">
                  <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center me-20">
                    <span className="mb-0 w-40-px h-40-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center radius-8 h6 mb-0">
                      <Icon
                        icon="streamline:bag-dollar-solid"
                        className="icon"
                      />
                    </span>
                  </div>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-md">
                      Total Tutor
                    </span>
                    <h6 className="fw-semibold my-1">{tutorCount}</h6>
                    <p className="text-sm mb-0">
                      New Tutors{" "}
                      <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                        +{newtutorCount}
                      </span>{" "}
                      in last one month
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dashboard Widget Start */}
      {(roleName === "Admin" || roleName === "Tutor") &&
        userName !== "E2TMT0001" && (
          <div className="col-xxl-3 col-sm-6">
            <div className="card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-2">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center">
                    <div className="w-64-px h-64-px radius-16 bg-base-50 d-flex justify-content-center align-items-center me-20">
                      <span className="mb-0 w-40-px h-40-px bg-purple flex-shrink-0 text-white d-flex justify-content-center align-items-center radius-8 h6 mb-0">
                        <Icon
                          icon="solar:wallet-bold"
                          className="text-white text-2xl mb-0"
                        />
                      </span>
                    </div>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-md">
                        Total Batch
                      </span>
                      <h6 className="fw-semibold my-1">{batchCount}</h6>
                      <p className="text-sm mb-0">
                        New Batches{" "}
                        <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                          +{newbatchCount}
                        </span>{" "}
                        in last one month
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      {/* Dashboard Widget End */}
    </>
  );
};

export default UnitCountFour;
